/**
 * Created by ivan on 11.04.18.
 */

const MagnetToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.MAGNET);

    this.onUpdateDragState = function () {};

    this.dragHandler = new UnitMagnetHandler();
    this.dragHandler.on("updateDragView", (...args) => {
        this.onUpdateDragState.call(this, ...args);
    }, this);
};

MagnetToolbarItem.prototype = Object.create(ToolbarItem.prototype);
MagnetToolbarItem.prototype.constructor = MagnetToolbarItem;

MagnetToolbarItem.prototype.getPrice = function () {
    return `@@${UnitMagnetHandler.PRICE}`;
};

MagnetToolbarItem.prototype.onDragStart = function () {
    if (!this.hintShown) {
        this.hintShown = true;
        cleverapps.centerHint.createTextHint(Messages.get("UnitMagnet.hint"));
    }
};

MagnetToolbarItem.prototype.onFollowPointer = function (touch) {
    this.dragHandler.searchTargets(touch);
};

MagnetToolbarItem.prototype.dragAction = function () {
    if (this.dragHandler.pullInUnits()) {
        return true;
    }
    return false;
};

MagnetToolbarItem.prototype.isVisible = function () {
    return levels.user.checkAvailable(cleverapps.config.availables.UNITMAGNET) && cleverapps.environment.isMainScene()
        && cleverapps.meta.getSelectedLocation().locationConfig.usesMagnet;
};